import { Component } from '@angular/core';
import { AuthService } from './services/auth.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from './services/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ntrip-caster-manager-fe';

  constructor(private auth: AuthService, private router: Router, private seo: SeoService) {
    // Apply SEO tags on initial load and on every navigation.
    this.seo.applyForUrl(this.router.url || '/');
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.seo.applyForUrl(e.urlAfterRedirects || e.url || '/');
      });
  }

  // use to store Tokens
  accessToken: string = ''; 
  decodedToken: any;

  isLoggedIn(): boolean {
    return this.auth.isLoggedIn();
  }

}
